import { FormInputArtifact, ResponseArtifactDTO } from '@dreamai/types';

export type SecureFormInputArtifact = FormInputArtifact & {
  secureRequestId?: string | null;
};

export const hasSecureRequestId = (
  artifact: ResponseArtifactDTO,
): artifact is SecureFormInputArtifact => {
  if (artifact.artifactType !== 'form_input') return false;
  if (!('secureRequestId' in artifact)) return false;
  const secureRequestId = artifact.secureRequestId;
  return typeof secureRequestId === 'string' && secureRequestId.length > 0;
};
